export default class StringHelper {
  static toLowerCase(value) {
    return (typeof value === 'string') ? value.toLowerCase() : value;
  }

  static replace(value, searchValue, replacer) {
    const regex = (typeof searchValue === 'string') ? new RegExp(searchValue, 'g') : searchValue;
    return (typeof value === 'string') ? value.replace(regex, replacer) : value;
  }

  static camelCaseToUnderscore(str) {
    return this.toLowerCase(this.replace(str, /([a-z])([A-Z])/g, '$1_$2' ));
  }
}
